import { render, staticRenderFns } from "./WpSearchInput.vue?vue&type=template&id=7afe381b"
import script from "./WpSearchInput.vue?vue&type=script&lang=js"
export * from "./WpSearchInput.vue?vue&type=script&lang=js"
import style0 from "./WpSearchInput.vue?vue&type=style&index=0&id=7afe381b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports